import { SpokenEnvironment } from '@spoken/config';

export const environment: SpokenEnvironment = {
	title: 'spOken',
	production: true,
	defaultLightTheme: 'whot',
	defaultDarkTheme: 'sunset',
	availableThemes: ['whot', 'light', 'dark', 'accessible', 'cupcake', 'bumblebee', 'emerald', 'corporate', 'synthwave', 'retro', 'cyberpunk', 'valentine', 'halloween', 'garden', 'forest', 'aqua', 'lofi', 'pastel', 'fantasy', 'wireframe', 'black', 'luxury', 'dracula', 'cmyk', 'autumn', 'business', 'acid', 'lemonade', 'night', 'coffee', 'winter', 'dim', 'nord', 'sunset', 'caramellatte', 'abyss', 'silk'],
	articles: {
		folders: {
			blog: '71a41913-4835-49b5-9370-c141b037495c',
			useCases: 'fd39a5cb-51ca-41a1-b927-f4b34f001da0',
			support: {
				articles: '150554ea-55f6-4a04-9693-13bf5b6c4363',
				tutorials: '9816c181-01ca-459a-b45e-76a45bc6116e',
			},
		},
	},
	sentry: {
		domain: 'spoken.systems',
		initConfig: {
			dsn: 'https://97aa98d77ba1749e049ad6611de8111a@o4508728233558016.ingest.us.sentry.io/4509321641787393',
			// Setting this option to true will send default PII data to Sentry.
			// For example, automatic IP address collection on events
			sendDefaultPii: true,
		},
	},
	billing: {
		stripe: {
			publicKey: 'pk_live_51GvhvWHmWKwDjdmyK2E4KqNrpgGfX7YJtpzFPX3y7QlOJKo5MRxg9RKFgVIjTFR6SlMN1oes16JxukxisCQlOfqV00e93GNu5y',
		},
	},
	support: {
		email: 'contact@spoken.systems',
	},
	acls: {
		operations: ['read', 'write', 'delete', 'share', 'create'],
	},
};
